'use strict';
/**
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('../').PeerData} PeerData
 */

/**
 * A list of unique peers.
 */

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var PeerList = /*#__PURE__*/function () {
  function PeerList() {
    _classCallCheck(this, PeerList);

    /** @type {PeerData[]} */
    this.list = [];
  }
  /**
   * Add a new peer. Returns `true` if it was a new one
   *
   * @param {PeerData} peerData
   */


  _createClass(PeerList, [{
    key: "push",
    value: function push(peerData) {
      if (!this.has(peerData.id)) {
        this.list.push(peerData);
        return true;
      }

      return false;
    }
    /**
     * Check if this PeerData is already in here.
     *
     * @param {PeerId} peerId
     */

  }, {
    key: "has",
    value: function has(peerId) {
      var match = this.list.find(function (i) {
        return i.id.equals(peerId);
      });
      return Boolean(match);
    }
    /**
     * Get the list as an array.
     */

  }, {
    key: "toArray",
    value: function toArray() {
      return this.list.slice();
    }
    /**
     * Remove the last element
     */

  }, {
    key: "pop",
    value: function pop() {
      return this.list.pop();
    }
    /**
     * The length of the list
     */

  }, {
    key: "length",
    get: function get() {
      return this.list.length;
    }
  }]);

  return PeerList;
}();

module.exports = PeerList;